<template>
    <form-wrapper>
        <div>
            <div class="upload-layout">
                <div class="header">
                    <p class="list">{{ $t('modals.pageData.header.subtitle') }}</p>
                </div>
                <div class="upload-section">
                    <h6 class="upload-patient-text">{{ $t('modals.pageData.uploadSection.title') }}</h6>
                    <div class="sample-file">
                        <p class="file-info">{{ $t('modals.pageData.uploadSection.fileInfo') }}</p>
                        <p class="sample-file-text">
                            <a :href="'/files/patient_sample_template.xlsx'" download>
                                {{ $t('modals.pageData.sampleFile.text') }}
                            </a>
                        </p>
                    </div>

                    <div class="file-upload">
                        <div class="outer">
                            <div class="inner">
                                <div v-if="fileUpload.selectedFileName" class="fileupload-name">
                                    <p class="file-name">
                                        {{ fileUpload.selectedFileName }}
                                        <span>{{ fileUpload.selectedFileSize }}</span>
                                    </p>
                                    <button class="delete-btn" @click="removeFile">
                                        <svg class="delete-icon">
                                            <use xlink:href="#icon-delete" />
                                        </svg>
                                    </button>
                                </div>

                                <p v-if="fileUpload.error" class="validation-error">
                                    {{ fileUpload.error }}
                                </p>
                            </div>
                            <button
                                v-if="fileUpload.selectedFileName"
                                class="continue-btn"
                                :disabled="!!fileUpload.error"
                                @click="handleAddPatient"
                            >
                                {{ $t('modals.pageData.buttons.upload') }}
                            </button>

                            <label v-else for="fileInput" class="upload-box">
                                <div>
                                    <svg class="upload">
                                        <use xlink:href="#icon-upload" />
                                    </svg>
                                    <input id="fileInput" type="file" class="fileInput" @change="handleFileChange" />
                                    <p class="browse">{{ $t('modals.pageData.fileUploadText.browse') }}</p>
                                    <p class="drag-text">{{ $t('modals.pageData.fileUploadText.dragDrop') }}</p>
                                </div>
                            </label>
                        </div>
                    </div>

                    <p v-if="fileUpload.isLoading">{{ $t('modals.pageData.status.loadingText') }}</p>

                    <p class="or-text">{{ $t('modals.pageData.status.orText') }}</p>
                    <button class="add-patient-btn" @click="toggleModal()">
                        {{ $t('modals.pageData.buttons.addPatient') }}
                    </button>
                </div>
            </div>
        </div>
        <add-patient-modal :isOpen="isPatientModel" @close="toggleModal()"></add-patient-modal>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import PatientAPI from 'api/PatientAPI'
    import AddPatientModal from 'components/page-elements/patient/AddPatientModal'

    export default {
        mixins: [FormMixin, HandleRequestMixin],
        components: { AddPatientModal },

        data() {
            return {
                fileUpload: {
                    selectedFile: null,
                    selectedFileName: '',
                    selectedFileSize: 0,
                    isLoading: false,
                    error: '',
                },
                isPatientModel: false,
            }
        },

        methods: {
            toggleModal() {
                this.isPatientModel = !this.isPatientModel
            },

            handleFileChange(event) {
                const file = event.target.files[0]
                if (!file) return

                const allowedExtensions = ['csv', 'xls', 'xlsx']
                const extension = file.name.split('.').pop().toLowerCase()

                this.fileUpload.error = ''
                this.fileUpload.selectedFile = null

                this.fileUpload.selectedFileName = file.name
                this.fileUpload.selectedFileSize = (file.size / (1024 * 1024)).toFixed(1)

                if (!allowedExtensions.includes(extension)) {
                    this.fileUpload.error = this.$t('modals.pageData.uploadWrongFileError.text')
                    return
                }

                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => {
                    this.fileUpload.selectedFile = { base64File: reader.result }
                }
            },

            removeFile() {
                this.fileUpload.selectedFile = null
                this.fileUpload.selectedFileName = ''
                this.fileUpload.selectedFileSize = 0
                this.fileUpload.error = ''
            },

            handleAddPatient() {
                if (!this.fileUpload.selectedFile || this.fileUpload.error) {
                    alert('Please select a valid file first!')
                    return
                }

                this.fileUpload.isLoading = true
                const userId = this.$auth.getUser().id

                PatientAPI.uploadPatientFile(userId, this.fileUpload.selectedFile, this.fileUpload.selectedFileName)
                    .then(() => {
                        this.$router.push('/patients/list/patients')
                    })
                    .finally(() => {
                        this.fileUpload.isLoading = false
                    })
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/components/patients/_patient';

    .validation-error {
        color: red;
        font-size: 0.85rem;
        margin-top: 4px;
        text-align: left;
    }
</style>
